import { render, staticRenderFns } from "./ConfirmReferralStatusModal.vue?vue&type=template&id=6dde0b9e&"
import script from "./ConfirmReferralStatusModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmReferralStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports